var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.showEditControls
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "form-group col-md-6" }, [
              _c("label", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.T.statementLanguage))
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentLanguage,
                      expression: "currentLanguage"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentLanguage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.languages, function(language) {
                  return _c(
                    "option",
                    {
                      key: language,
                      attrs: { "markdown-contents": _vm.currentMarkdown },
                      domProps: { value: language }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.getLanguageNameText(language)) + " "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _c(
              "div",
              {
                staticClass: "form-group col-md-6",
                class: { "has-error": _vm.errors.includes("message") }
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(_vm._s(_vm.T.problemEditCommitMessage))
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.commitMessage,
                      expression: "commitMessage"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.commitMessage },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.commitMessage = $event.target.value
                    }
                  }
                })
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", {
            ref: "markdownButtonBar",
            staticClass: "wmd-button-bar"
          }),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.currentMarkdown,
                expression: "currentMarkdown",
                modifiers: { lazy: true }
              }
            ],
            ref: "markdownInput",
            staticClass: "wmd-input",
            domProps: { value: _vm.currentMarkdown },
            on: {
              change: function($event) {
                _vm.currentMarkdown = $event.target.value
              }
            }
          })
        ]),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("h1", { staticClass: "title text-center" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _c("omegaup-markdown", {
              attrs: {
                markdown: _vm.currentMarkdown,
                "source-mapping": _vm.statement.sources,
                "image-mapping": _vm.statement.images,
                preview: "true"
              }
            }),
            _vm.markdownType === "statements"
              ? [
                  _c("hr"),
                  _c("div", [
                    _c("em", [
                      _vm._v(_vm._s(_vm.T.wordsSource) + ": "),
                      _c("span", { staticClass: "source" }, [
                        _vm._v(_vm._s(_vm.source))
                      ])
                    ])
                  ]),
                  _c("div", [
                    _c("em", [
                      _vm._v(_vm._s(_vm.T.wordsProblemsetter) + ": "),
                      _c(
                        "a",
                        { staticClass: "problemsetter" },
                        [
                          _vm.problemsetter
                            ? _c("omegaup-user-username", {
                                attrs: {
                                  classname: _vm.problemsetter.classname,
                                  linkify: true,
                                  username: _vm.problemsetter.username
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]),
    _vm.showEditControls
      ? _c("div", { staticClass: "card-footer" }, [
          _c(
            "form",
            {
              staticClass: "row",
              attrs: { enctype: "multipart/form-data", method: "post" },
              on: { submit: _vm.onSubmit }
            },
            [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "submit",
                      disabled: _vm.commitMessage === ""
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.markdownType === "solutions"
                            ? _vm.T.problemEditFormUpdateSolution
                            : _vm.T.problemEditFormUpdateMarkdown
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c("input", {
                attrs: { type: "hidden", name: "message" },
                domProps: { value: _vm.commitMessage }
              }),
              _c("input", {
                attrs: { type: "hidden", name: "contents" },
                domProps: { value: JSON.stringify(_vm.statements) }
              }),
              _c("input", {
                attrs: { type: "hidden", name: "directory" },
                domProps: { value: _vm.markdownType }
              }),
              _c("input", {
                attrs: { type: "hidden", name: "problem_alias" },
                domProps: { value: _vm.alias }
              }),
              _c("input", {
                attrs: { type: "hidden", name: "request", value: "markdown" }
              })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }